import { createContext, useContext, useMemo } from "react";
import { IDispositionTypeService } from "../services/DispositionTypeService";
import { createDispositionTypeService } from "./Bootstrap";
import { useHttpRequestService } from "./HttpRequestContext";

const DispositionTypeContext = createContext<IDispositionTypeService | null>(null);

export const DispositionTypeProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const httpRequestService = useHttpRequestService();
    const dispositionTypeService = useMemo(() => createDispositionTypeService(httpRequestService), [httpRequestService]);

    return (
        <DispositionTypeContext.Provider value={dispositionTypeService}>
            {children}
        </DispositionTypeContext.Provider>
    );
}

export const useDispositionTypeService = () => {
    const dispositionTypeService = useContext(DispositionTypeContext);
    if (!dispositionTypeService) {
        throw new Error('useDispositionTypeService must be used within a DispositionTypeProvider');
    }
    return dispositionTypeService;
};
